export const MAX_IMAGE_SIZE = 5 * 1024 * 1024

export function validateImageSize(
  file: File,
  maxSize: number = MAX_IMAGE_SIZE
): boolean {
  return file.size <= maxSize
}
